'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_sc_Iterable$() {
  this.iV = null;
  $j_java$002elang$002e$002dObject.$ct_sc_IterableFactory$Delegate__sc_IterableFactory__(this, $j_java$002elang$002e$002dObject.$m_sci_Iterable$());
}
export { $c_sc_Iterable$ as $c_sc_Iterable$ };
$p = $c_sc_Iterable$.prototype = new $j_java$002elang$002e$002dObject.$h_sc_IterableFactory$Delegate();
$p.constructor = $c_sc_Iterable$;
/** @constructor */
function $h_sc_Iterable$() {
}
export { $h_sc_Iterable$ as $h_sc_Iterable$ };
$h_sc_Iterable$.prototype = $p;
var $d_sc_Iterable$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_sc_Iterable$, "scala.collection.Iterable$", ({
  sg: 1,
  bT: 1,
  a: 1,
  L: 1
}));
export { $d_sc_Iterable$ as $d_sc_Iterable$ };
var $n_sc_Iterable$;
function $m_sc_Iterable$() {
  if ((!$n_sc_Iterable$)) {
    $n_sc_Iterable$ = new $c_sc_Iterable$();
  }
  return $n_sc_Iterable$;
}
export { $m_sc_Iterable$ as $m_sc_Iterable$ };
